var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHyperBannerPurpleBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 19,
    viewBox: "0 0 61 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20058,
    y: 0.787008,
    width: 59.0149,
    height: 17.358,
    rx: 8.02879,
    fill: "#6C53E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.20058,
    y: 0.787008,
    width: 59.0149,
    height: 17.358,
    rx: 8.02879,
    stroke: "white",
    strokeWidth: 1.12773
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.20058,
    y: 0.787008,
    width: 59.0149,
    height: 17.358,
    rx: 8.02879,
    stroke: "url(#paint0_linear_2901_1030891)",
    strokeOpacity: 0.16,
    strokeWidth: 1.12773
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6883 8.29087L18.7414 5.66309H15.7656L19.4279 11.0344V13.2687H21.9456V11.0344L25.6254 5.66309H22.6496L20.6883 8.29087Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3158 5.66309H25.9844V13.2687H28.502V11.7265H31.4028C32.1867 11.7265 34.5901 11.396 34.5901 8.58063C34.5901 5.76526 32.0334 5.66309 31.3158 5.66309ZM31.236 9.48663H28.502V7.90213H31.1929C31.5465 7.90213 32.2345 7.92847 32.2345 8.66445C32.2345 9.40042 31.6223 9.48663 31.236 9.48663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1562 13.268H43.5425V11.1582H37.6739V10.4741H43.1705V8.44902H37.6739V7.7761H43.5425V5.66797H35.1562V13.268Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8024 11.024C52.5408 10.6249 53.197 9.86499 53.197 8.45691C53.197 5.75967 50.6426 5.66309 49.9242 5.66309H44.3438V13.2687H46.8614V11.4686H49.1507L50.4407 13.2551L53.3558 13.2679L51.8024 11.024ZM49.6863 9.24796H46.8614V7.88377H49.6456C49.9785 7.88377 50.6274 7.90692 50.6274 8.54072C50.6274 9.17452 50.0503 9.24796 49.6863 9.24796Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 5.66699H8.05859V8.20059H10.5922V5.66699Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5922 10.7358H8.05859V13.2694H10.5922V10.7358Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5898 8.20068V10.7343H13.1234V13.2687H15.657V10.7343V8.20068H13.1234H10.5898Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2901_1030891",
    x1: 30.708,
    y1: 0.223145,
    x2: 30.708,
    y2: 18.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperBannerPurpleBg);
export default __webpack_public_path__ + "static/media/hyper-banner-purple-bg.226224fb58ce7903ca8b5efb51db3e6a.svg";
export { ForwardRef as ReactComponent };